import { collection, doc, getDocs, addDoc, deleteDoc, query, where, limit, setDoc, updateDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../shared/api/firebase/config';

export async function checkDuplicatePetition(appId, authenticityHash, primaryClientId) {
  const documentsCol = collection(db, 'artifacts', appId, 'public', 'data', 'documents');
  const dupQuery = query(
    documentsCol,
    where('authenticityHash', '==', authenticityHash),
    where('clientId', '==', primaryClientId),
    where('type', '==', 'PETITION'),
    limit(1)
  );
  const dupSnap = await getDocs(dupQuery);
  return dupSnap.empty ? null : dupSnap.docs[0].data();
}

export async function createPetitionIntent(appId, data) {
  const documentsCol = collection(db, 'artifacts', appId, 'public', 'data', 'documents');
  const documentRef = doc(documentsCol);
  await setDoc(documentRef, { ...data, id: documentRef.id }, { merge: true });
  return documentRef;
}

export async function commitPetition(documentRef, payload) {
  await updateDoc(documentRef, payload);
}

export async function addPetitionNote(appId, primaryClientId, noteData) {
  const notesRef = collection(db, 'artifacts', appId, 'public', 'data', 'clients', primaryClientId, 'notes');
  await addDoc(notesRef, { ...noteData, createdAt: serverTimestamp() });
}

export async function rollbackPetition(documentRef) {
  await deleteDoc(documentRef);
}
